import React from 'react';
import { motion } from 'framer-motion';
import { useLanguage } from '../hooks/useLanguage';
import { CornerBrackets } from './CornerBrackets';
import { Cpu, Cloud, Briefcase, Wifi, ShieldCheck } from 'lucide-react';
export function ServicesGrid() {
  const {
    t,
    language
  } = useLanguage();
  const icons = [Cpu, Cloud, Briefcase, Wifi, ShieldCheck];
  const services = Object.values(t.services.items);
  // Split title to highlight "Expertise" in cyan
  const titleParts = language === 'fr' ? {
    before: "Nos Domaines d'",
    highlight: 'Expertise'
  } : {
    before: 'Our Areas of ',
    highlight: 'Expertise'
  };
  return <section className="py-24 bg-black/90 relative" data-id="element-344">
      <div className="max-w-7xl mx-auto px-4" data-id="element-345">
        {/* Section Header */}
        <div className="text-center mb-16" data-id="element-346">
          <h2 className="font-cyber text-4xl md:text-5xl font-bold text-white mb-4 tracking-wider" data-id="element-347">
            {titleParts.before}
            <span className="text-cyan" data-id="element-348">{titleParts.highlight}</span>
          </h2>
          <p className="text-gray-500 uppercase tracking-widest text-sm" data-id="element-349">
            {t.services.subtitle}
          </p>
        </div>

        {/* Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-350">
          {services.map((service, index) => {
          const Icon = icons[index];
          return <motion.div key={index} initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} transition={{
            delay: index * 0.1
          }} className="group relative p-8 bg-dark-card border border-white/5 hover:border-cyan/50 transition-colors duration-300" data-id="element-351">
                <CornerBrackets className="opacity-0 group-hover:opacity-100 transition-opacity duration-300" color="cyan" data-id="element-352" />

                <div className="relative z-10" data-id="element-353">
                  <div className="w-12 h-12 mb-6 flex items-center justify-center border border-cyan/30 bg-cyan/5 text-cyan group-hover:bg-cyan group-hover:text-black transition-all duration-300" data-id="element-354">
                    <Icon size={24} data-id="element-355" />
                  </div>

                  <h3 className="font-cyber text-xl font-bold text-white mb-3 group-hover:text-cyan transition-colors" data-id="element-356">
                    {service.title}
                  </h3>

                  <p className="text-gray-500 text-sm leading-relaxed group-hover:text-gray-300 transition-colors" data-id="element-357">
                    {service.desc}
                  </p>
                </div>
              </motion.div>;
        })}
        </div>
      </div>
    </section>;
}